/**
 * Initialise Ajax Load More (ALM) ou exécute des traitements après chargement ALM.
 *
 * @param {Object} options
 * @param {boolean} [options.skipStart=false] - Si true, n'appelle pas ajaxloadmore.start()
 *   (à utiliser quand on est appelé depuis almOnLoad pour éviter un second appel API identique).
 */
export function initAjaxLoadMore(options = {}) {
  if (typeof window.ajaxloadmore !== 'object') return;

  const { skipStart = false } = options;

  if (!skipStart) {
    const pagination = document.querySelector('.alm-btn-wrap .alm-paging ');
    if (pagination) return;

    const target = document.querySelector(
      '.ajax-load-more-wrap[data-id="product-grid"], .ajax-load-more-wrap[data-id="blog-grid"]'
    );
    if (!target) return;

    window.ajaxloadmore.start(target);
  }
}
